// extracted by mini-css-extract-plugin
export default {"inputWithSearch":"SearchInput_inputWithSearch__xeabH","inputContainer":"SearchInput_inputContainer__OhReI","icon":"SearchInput_icon__ioTJs"};